// extracted by mini-css-extract-plugin
export default {"container":"style_container__nY90m","content":"style_content__BMq7K"};